import { render, staticRenderFns } from "./houseApartment.vue?vue&type=template&id=e2563188&"
import script from "./houseApartment.vue?vue&type=script&lang=js&"
export * from "./houseApartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\TeamCity\\buildAgent\\work\\d66fd695757ba5a4\\src\\SABONyproduktion.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e2563188', component.options)
    } else {
      api.reload('e2563188', component.options)
    }
    module.hot.accept("./houseApartment.vue?vue&type=template&id=e2563188&", function () {
      api.rerender('e2563188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/houseModel/components/houseApartment.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/components/houseApartment.vue
// module id = 469
// module chunks = 0